import { parseAbi } from "viem";
export const SafeCreateCallAbi = parseAbi([
    "function performCreate(uint256 value, bytes memory deploymentData) public returns (address newContract)",
    "function performCreate2(uint256 value, bytes memory deploymentData, bytes32 salt) public returns (address newContract)"
]);
//# sourceMappingURL=SafeCreateCallAbi.js.map